import type { OutputData } from "@smartsuite/automation-engine-api";
import type { ReactElement } from "react";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";
import { addEmptyValueIfNeeded } from "../../../../../ActivityGrid/ActivityGrid.helpers";
import { getOutputValue } from "./utils";

interface OutputFieldsProps {
  outputs: OutputData[];
}

export const OutputFields = ({
  outputs,
}: OutputFieldsProps): ReactElement | null => {
  if (outputs.length === 0) {
    return null;
  }

  return (
    <>
      {outputs.map((output) => (
        <ActivityDetailsItem key={output.outputId} label={output.outputLabel}>
          {addEmptyValueIfNeeded(getOutputValue(output.value))}
        </ActivityDetailsItem>
      ))}
    </>
  );
};
